const {AoflElement, store, abcmouseTrackerQueue} = aofljs;
import './sdo';
/**
 * @summary CreateShortcutPcPopup
 * @class CreateShortcutPcPopup
 * @extends {AoflElement}
 */
class CreateShortcutPcPopup extends AoflElement {
  /**
   * Creates an instance of CreateShortcutPcPopup.
   * Stores svgs in properties, subscribes to and updates with store.
   *
   * @memberof CreateShortcutPcPopup
   */
  constructor() {
    super(store);
    this.unsubscribeStore = store.subscribe(() => this.mapProperties());
    this.mapProperties();
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CreateShortcutPcPopup
   */
  static get is() {
    return 'create-shortcut-pc-popup';
  }

  /**
   *
   * @memberof CreateShortcutPcPopup
   */
  connectedCallback() {
    super.connectedCallback();
    abcmouseTrackerQueue.enqueueEvent({
      url: this.pageInfo.pageLoadUrl,
      page_info_key: this.pageInfo.page_info_key
    });
  }

  /**
   * Maps the components properties to store.
   *
   * @memberof CreateShortcutPcPopup
   */
  mapProperties() {
    let state = store.getState().createShortcutPcPopup;
    this.showInitial = state.showInitial;
  }

  /**
   *
   *
   * @memberof CreateShortcutPcPopup
   */
  handleClose() {
    store.commit([
      {
        stateAlias: 'createShortcutPcPopup',
        mutationId: 'toggleShowInitial',
        payload: true
      }
    ]);
  }

  /**
   *
   *
   * @memberof CreateShortcutPcPopup
   */
  showDetailed() {
    store.commit([
      {
        stateAlias: 'createShortcutPcPopup',
        mutationId: 'toggleShowInitial',
        payload: false
      }
    ]);
  }

  /**
   *
   *
   * @param {any} e
   * @memberof CreateShortcutPcPopup
   */
  handleClickShortcutLink(e) {
    e.preventDefault();
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CreateShortcutPcPopup
   */
  static get properties() {
    return {
      pageInfo: {
        type: Object,
        value: {
          pageLoadUrl: 'homepage',
          page_info_key: 'create_shortcut_popup'
        }
      }
    };
  }

  /**
   * Logic that runs when this component unmounts
   *
   * @memberof CreateShortcutPcPopup
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubscribeStore();
  }
}

window.customElements.define(CreateShortcutPcPopup.is, CreateShortcutPcPopup);

export default CreateShortcutPcPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/create-shortcut-pc-popup/create-shortcut-pc-popup.js